import "../css/whyChooseUs.css";
import {
  FaTruck,
  FaLock,
  FaAward,
  FaHeadset
} from "react-icons/fa";

function WhyChooseUs() {

  const features = [

    {
      icon: <FaAward />,
      title: "Premium Quality",
      desc: "Carefully selected wines, spirits and premium liquor brands."
    },

    {
      icon: <FaTruck />,
      title: "Fast Delivery",
      desc: "Quick and reliable shipping directly to your doorstep."
    },

    {
      icon: <FaLock />,
      title: "Secure Payments",
      desc: "100% secure checkout using trusted payment gateways."
    },

    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      desc: "Friendly customer support whenever you need assistance."
    }

  ];

  return (

    <section className="why-section">

      <div className="container">

        <h2>Why Choose SIP LIQUORS?</h2>

        <p className="why-subtitle">
          We are committed to providing quality products,
          secure shopping, and exceptional customer service.
        </p>

        <div className="why-grid">

          {features.map((item, index) => (

            <div
              className="why-card"
              key={index}
            >

              <div className="why-icon">

                {item.icon}

              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );

}

export default WhyChooseUs;